import { IconProps } from './';

const defaultSize = 48;

export const DotIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size ?? defaultSize;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={sizeToUse}
      height={sizeToUse / 2}
      viewBox="0 0 512 512">
      <path fill="#b20101" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z" />
    </svg>
  );
};
